import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, useState } from 'react';
import { Provider } from 'jotai';

import { router } from '../router';

import { RouterProvider } from '../../../shared/client/helpers/react-router-dom.helpers';
import { ErrorBoundary } from '../../../shared/client/components/error-boundary/error-boundary';

export const Wrapper = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <StrictMode>
      <ErrorBoundary>
        <Provider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </Provider>
      </ErrorBoundary>
    </StrictMode>
  );
};
